import { render, staticRenderFns } from "./TheoryExamParticipants.vue?vue&type=template&id=56913d90&"
import script from "./TheoryExamParticipants.vue?vue&type=script&lang=ts&"
export * from "./TheoryExamParticipants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports